import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    border-radius: 10px;
    border-style: solid;
    overflow: hidden;
    border-width: 1px;
    border-color: ${props => props.theme.borderColor};
    -webkit-box-shadow: 1px 1px 15px 1px rgb(207, 211, 228);
    -moz-box-shadow: 1px 1px 15px 1px rgb(207, 211, 228);
    box-shadow: 1px 1px 15px 1px rgb(207, 211, 228);
    background: white;
    &:hover {
        transform: scale(1.05); 
    }
}
`;

export const ContentContainer = styled.div`
    padding: 10px;
}
`;

export const Header = styled.div`
    height: 125px;
    width: 100%;
    background: linear-gradient(45deg, #1F85FF 0%, #196ac6 100%);
    > * {
        margin: 0 auto;
        position: relative;
        top: 50%;
        transform: translateY(-50%);
        width: 100%;
        height: 60%;
        opacity: 90%;
    }
`;
export const Title = styled.div`
    font-weight: 450;
    color: #6b6b6b;
    font-size: 1.2em;
    margin-bottom: 10px;
}
`;

export const Description = styled.div`
    font-weight: 400;
    color: #6b6b6b;
    font-size: 1.0em;
}
`;
